import * as czLocaleItems from './enums-cz';
import * as enLocaleItems from './enums-en';

export function getItemsByLocale(locale: string) {
  switch (locale) {
    case 'en':
      return enLocaleItems;
    default:
      return czLocaleItems;
  }
}
